import { filter, distinctUntilChanged, map } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, NO_SCROLL, PORTFOLIO } from 'src/app';
import { BootstrapService, ContractsService } from 'src/core';

import { Subscription } from 'rxjs';

@Component({
  selector: 'hb-advisor-search',
  templateUrl: 'advisorSearch.component.html',
  styleUrls: ['./advisorSearch.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdvisorSearchComponent implements OnInit, OnDestroy {
  itsFirstTime = true;

  contractsList: any[] = [];

  startsWithList: any[] = [];
  containsList: any[] = [];

  curatedContractsList: any[] = [];
  selectedContract: string;
  typingTimer: any;
  hasResults = false;
  typingContract: string;

  searchIsEmpty = false;

  public currentContract: any;
  private lastContractShown: string;
  private contractsSubscription: Subscription;
  private currentContractSubscription: Subscription;

  private attachedClick = true;
  constructor(
    private store: Store<AppState>,
    private contractsService: ContractsService,
  ) {}

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    if (this.currentContractSubscription) {
      this.currentContractSubscription.unsubscribe();
    }

    if (this.contractsSubscription) {
      this.contractsSubscription.unsubscribe();
    }
  }

  changeContract(contractId: string): void {
    this.selectedContract = contractId;

    if (this.lastContractShown !== contractId) {
      this.contractsService.getContractInfo(contractId).subscribe(
        (result) => {
          if (!result) {
            this.selectedContract = this.lastContractShown;
          } else {
            this.typingContract = '';
            this.hasResults = false;
            this.noScroll(this.hasResults);
          }
        },
        () => {
          // Do nothing, just catch error
        },
      );
    }
  }

  private uniq(a: any) {
    return Array.from(new Set(a));
  }

  public searchContract() {
    const DELAY_TIME = 200;

    if (this.contractsList.length > 0 && this.typingContract.length > 0) {
      clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(() => {
        this.itsFirstTime = false;

        this.containsList = this.contractsList.filter((contract: any) => {
          if (contract !== undefined) {
            if (contract.contractId.indexOf(this.typingContract) !== -1) {
              contract.startsWith = false;
              return true;
            }
          }
        });

        this.startsWithList = this.contractsList.filter((contract: any) => {
          if (contract !== undefined) {
            if (contract.contractId.startsWith(this.typingContract)) {
              contract.startsWith = true;
              return true;
            }
          }
        });

        const globals = this.contractsList.filter((contract: any) => {
          if (contract !== undefined) {
            return contract.isGlobal;
          }
        });

        this.curatedContractsList = this.uniq([
          ...globals,
          ...this.startsWithList,
          ...this.containsList,
        ]);

        this.hasResults = this.curatedContractsList.length > 0 ? true : false;

        this.searchIsEmpty = this.hasResults;

        this.noScroll();
      }, DELAY_TIME);
    } else {
      this.hasResults = false;
      this.searchIsEmpty = false;
      this.curatedContractsList = [];
    }
  }

  public restoreSearch($event: any) {
    this.hasResults = false;
    this.searchIsEmpty = false;
    this.itsFirstTime = true;
    this.typingContract = '';
    this.curatedContractsList = [];
    this.startsWithList = [];
    this.containsList = [];
    this.noScroll();
  }

  private init(): void {
    this.contractsSubscription = this.store
      .select('contracts')
      .pipe(
        map((values: any) => values.toJS()),
        distinctUntilChanged(),
      )
      .subscribe((contracts: any[]) => {
        this.contractsList = contracts;
      });

    this.currentContractSubscription = this.store
      .select('currentContract')
      .pipe(
        map((values: any) => values.get('contractID')),
        filter((contractId: any) => contractId !== undefined),
        distinctUntilChanged(),
      )
      .subscribe((contractId: any) => {
        this.currentContract = contractId;
        this.selectedContract = contractId;
        this.lastContractShown = contractId;
      });
  }

  /**
   * @method closeWhenOutsideClick : Action to be executed when user clics outside the component
   * @param event : Contains the clic event
   */
  public closeWhenOutsideClick(event: any) {
    if (this.hasResults) {
      this.attachedClick = !this.attachedClick;
      this.hasResults = !this.hasResults;
    }
    this.hasResults = false;
    this.searchIsEmpty = false;
    this.itsFirstTime = true;
    this.curatedContractsList = [];

    this.noScroll(this.hasResults);
  }

  private noScroll(flag?: boolean) {
    const block = flag !== undefined ? flag : this.hasResults;

    this.store.dispatch({
      type: NO_SCROLL,
      payload: { block, source: 'AdvisorSearchComponent' },
    });
  }

  /**
   * @method navDown : Gets call when user clic or hit a keyboard key inside the search field.
   * @param event : event received. Can be a clic or keyboard key
   */
  private navDown(event: any) {
    const code = event.keyCode;
    const source = event.srcElement;
    let tab: any;
    let key: any;

    if (code === 13) {
      if (source.classList.contains('option')) {
        tab = source.dataset.tab;
        key = source.dataset.key;

        this.changeContract(tab);
      }
    }
    if (code === 40) {
      if (source.classList.contains('search-issue')) {
        // input
        source.parentElement.parentElement.querySelector('.option').focus();
      } else if (source.classList.contains('option')) {
        // option
        if (source.nextElementSibling === null) {
          return;
        }
        source.nextElementSibling.focus();
      }
    } else if (code === 38) {
      // up
      if (source.classList.contains('option')) {
        if (source.previousElementSibling === null) {
          return;
        }
        source.previousElementSibling.focus();
      }
    }
  }
}
